import React, { useRef } from 'react';
import { Field as FinalFormField, useForm } from 'react-final-form';

import type { TField } from './models';

export const Field = <T,>({
    data,
    dispatchesFocus,
    name,
    receivesFocus,
    render,
    ...rest
}: TField<T>) => {
    const { mutators } = useForm();
    const ref = useRef<HTMLInputElement>(null);

    return (
        <FinalFormField
            {...rest}
            data={{
                dispatchesFocus,
                onComplete: mutators.onComplete,
                onUpdateFormAction: mutators.onUpdateFormAction,
                receivesFocus,
                ref,
                ...data,
            }}
            name={name}
            render={render}
        />
    );
};
